/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  Input,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { RoutingService } from 'src/app/service/routing.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PortfolioNameComponent } from '../news-portfolio/portfolio-name/portfolio-name.component';
import { QueryNameComponent } from '../news-query/query-name/query-name.component';
import { DialogTableComponent } from '../../../micro-components/dialog-table/dialog-table.component';
import { AuditData } from 'src/app/cockpit/main-news/news-audit-view/audit-data.service';
import { EntityInfoService } from 'src/app/shared/services/metadata-api/entity-info.service';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-audit-title',
  templateUrl: './news-audit-title.component.html',
  styleUrls: ['./news-audit-title.component.scss'],
})
export class NewsAuditTitleComponent implements OnChanges {
  @Input() auditData: AuditData;
  @Input() loading = false;
  params: any;
  previousValue: any;
  theme = 'dark';
  entities: any;
  folio: any;
  folios: any;
  customScore: any;

  constructor(
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
    public config: ConfigService,
    public dialog: MatDialog,
    public entityInfoService: EntityInfoService,
    private portfolioApi: PortfolioApiService,
  ) {
    this.customScore = this.auth.scorelabSettings.defaultScore;
    this.route.queryParams.subscribe((params) => {
      this.params = params;

      if (this.routing.reFresh(params, this.previousValue, ['score'])) {
        this.customScore = params.score
          ? params.score
          : this.auth.scorelabSettings.defaultScore;
      }

      this.theme = this.routing.theme;

      if (
        this.routing.reFresh(params, this.previousValue, [
          'id',
          'groupId',
          'portfolioId',
        ])
      ) {
        if (this.routing.isFolio()) {
          if (this.portfolioApi.portfolios) {
            this.setEntities();
          } else {
            this.entities = [];
          }
        }
      }
      this.previousValue = params;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.auditData && changes.auditData.currentValue) {
      if (this.routing.isFolio() && this.portfolioApi.portfolios) {
        this.setEntities();
      }
    }
  }

  setEntities() {
    if (this.routing.isFolio()) {
      if (this.portfolioApi.portfolios) {
        const portfolioId = this.params.portfolioId
          ? this.params.portfolioId
          : this.params.id;
        this.folio = this.portfolioApi.portfolios.filter((el) => {
          return el.uid === portfolioId;
        })[0];
        const entities = this.folio.content;
        this.entityInfoService.getEntitiesInfo(entities).subscribe((result) => {
          this.entities = Object.values(result).filter((element) => {
            return element !== null;
          });
          this.entities.forEach((item) => {
            item.name =
              item.name !== 'PNE'
                ? item.name
                : item.alpha_id.split('.')[1] +
                  ' (' +
                  item.alpha_id.split('.')[0] +
                  ')';
          });
        });
      } else {
        this.entities = [];
      }
    }
  }

  getFlagTooltip(type) {
    const threshold = this.auth.scorelabSettings.defaultFlag.threshold;
    const scoreName = this.auth.getScoresInfo(
      this.auth.scorelabSettings.defaultFlag.score_type,
    )['full'];
    let score;
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      score = this.auditData.flagScore + ' of the ' + scoreName;
    } else {
      score = this.auditData.flagScore?.toFixed(2);
    }
    let tooltip = '';
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      if (type === 'warning') {
        tooltip =
          'Current value ' +
          score +
          ' crossed the set threshold of ' +
          threshold +
          '.';
      } else if (type === 'caution') {
        tooltip =
          'One of the ' +
          scoreName +
          ' values in the past year crossed the set threshold of ' +
          threshold +
          '.';
      }
    } else {
      if (type === 'warning') {
        tooltip =
          'One or more of the events associated with ' +
          scoreName +
          ' occurred in the past 100 days. Current value ' +
          score +
          ' crossed the set threshold of ' +
          threshold +
          '.';
      } else if (type === 'caution') {
        tooltip =
          'One or more of the events associated with ' +
          scoreName +
          ' occurred in the past 465 days. One of the values in the past year crossed the set threshold of ' +
          threshold +
          '.';
      }
    }
    return {
      tooltip: tooltip,
      score_type: this.auth.scorelabSettings.defaultFlag.score_type,
      score_name: this.auth.getScoresInfo(
        this.auth.scorelabSettings.defaultFlag.score_type,
      )['name'],
      score_threshold:
        this.auth.scorelabSettings.defaultFlag.threshold_setting ===
        'ABOVE_EQUAL'
          ? 'High'
          : 'Low',
    };
  }

  appendItem(option: 'add' | 'create') {
    if (this.routing.isMarket()) {
      this.dialog.open(PortfolioNameComponent, {
        data: { action: option, entity: this.auditData.entity },
      });
    }
    if (this.routing.isSearch()) {
      this.dialog.open(QueryNameComponent, {
        data: { action: option, query: this.auditData.entity },
      });
    }
  }
  select(item) {
    if (item === 'overall') {
      if (this.routing.isFolio()) {
        this.auditData.entity.type = 'Portfolio';
        this.auditData.entity.name = this.folio.name;
        this.router.navigate([], {
          queryParams: {
            id: this.params.portfolioId
              ? this.params.portfolioId
              : this.params.id,
            type: null,
            newstype: null,
            portfolioId: null,
            score: null,
            time: this.params.score ? null : this.params.time,
            reflow: Math.random(),
            focused_score: this.customScore ? this.customScore : null,
          },
          queryParamsHandling: 'merge',
        });
      }
    } else {
      if (this.routing.isFolio()) {
        this.auditData.entity.type = item.type;
        this.auditData.entity.name = item.name;

        const newParams = {
          id: item.alpha_id,
          type: item.type,
          newstype: null,
          portfolioId: this.params.portfolioId
            ? this.params.portfolioId
            : this.params.id,
          score: null,
          time: this.params.time,
          reflow: Math.random(),
          focused_score: null,
        };
        this.router.navigate([], {
          queryParams: newParams,
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  openDialog(entity: any) {
    this.dialog.open(DialogTableComponent, {
      data: {
        title: 'Sanctions on ' + entity.name,
        table: entity.sanctions.map((sanction: any) => ({
          authority: sanction.sanctioned_by.name,
          authorityId: sanction.sanctioned_by.alpha_id,
          authorityType: sanction.sanctioned_by.type,
          program: sanction.program,
          start: sanction.sanctioned_from,
          end: sanction.sanctioned_to,
        })),
      },
      width: '60%',
    });
  }
}
